module.exports = __webpack_public_path__ + "img/table.c30649bb.png";